import { useEntity } from '@backstage/plugin-catalog-react';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { AccessBindingsManager } from './AccessBindingsManager';
import { accessTranslationRef } from '../translation';

function buildEntityBindingsScope(entity: {
  kind?: string;
  metadata: { namespace?: string; name: string };
  spec?: { type?: string };
  relations?: Array<{ targetRef: string }>;
}):
  | {
      filterTargetRef: string;
      lockTargetRef: boolean;
      defaultTargetRef?: string;
      relatedProjectRefs?: readonly string[];
      allowedTargetKinds?: readonly ('Component' | 'Cluster' | 'Project')[];
    }
  | {
      filterSubjectRef: string;
      initialSubjectRef: string;
    }
  | undefined {
  const namespace = entity.metadata.namespace ?? 'default';

  if (entity.kind === 'Component') {
    return {
      filterTargetRef: `component:${namespace}/${entity.metadata.name}`,
      defaultTargetRef: `component:${namespace}/${entity.metadata.name}`,
      relatedProjectRefs:
        entity.relations?.map(relation => relation.targetRef) ?? [],
      allowedTargetKinds: ['Component', 'Project'],
      lockTargetRef: false,
    };
  }

  if (
    entity.kind === 'Resource' &&
    (entity.spec?.type === 'kubernetes-cluster' ||
      entity.spec?.type === 'project')
  ) {
    return {
      filterTargetRef: `resource:${namespace}/${entity.metadata.name}`,
      lockTargetRef: true,
    };
  }

  if (entity.kind === 'User' || entity.kind === 'Group') {
    const subjectKind = entity.kind.toLocaleLowerCase('en-US');
    const ref = `${subjectKind}:${namespace}/${entity.metadata.name}`;

    return {
      filterSubjectRef: ref,
      initialSubjectRef: ref,
    };
  }

  return undefined;
}

export const EntityAccessBindingsContent = () => {
  const { entity } = useEntity();
  const { t } = useTranslationRef(accessTranslationRef);
  const bindingsScope = buildEntityBindingsScope(entity);

  if (!bindingsScope) {
    return null;
  }

  return (
    <AccessBindingsManager title={t('bindings.cardTitle')} {...bindingsScope} />
  );
};
